import React, { useRef, useEffect, useState } from 'react';

const WebView = ({ 
  src, 
  className = '', 
  style = {},
  allowFullScreen = true,
  sandbox = 'allow-scripts allow-same-origin allow-forms allow-popups allow-modals',
  title = 'WebView',
  showCredentials = false
}) => {
  const iframeRef = useRef(null);
  const [credentials, setCredentials] = useState({
    email: 'profsa35@gmail.com',
    password: 'Rayglan@1957'
  });
  const [showPassword, setShowPassword] = useState(false);

  useEffect(() => {
    const iframe = iframeRef.current;
    if (!iframe) return;

    // Handle iframe load events
    const handleLoad = () => {
      console.log('WebView loaded:', src);
    };

    const handleError = (error) => {
      console.error('WebView error:', error);
    };

    iframe.addEventListener('load', handleLoad);
    iframe.addEventListener('error', handleError);

    return () => {
      iframe.removeEventListener('load', handleLoad);
      iframe.removeEventListener('error', handleError);
    };
  }, [src]);

  // Function to copy text to clipboard
  const copyToClipboard = async (text) => {
    try {
      await navigator.clipboard.writeText(text);
      // You could add a toast notification here if you have one
      console.log('Copied to clipboard:', text);
    } catch (err) {
      console.error('Failed to copy: ', err);
    }
  };

  return (
    <div className={`webview-container ${className}`} style={style}>
      {/* Simple Credentials */}
      {showCredentials && (
        <div className="bg-gray-100 p-3 mb-3 rounded text-sm">
          <div className="flex items-center gap-4">
            <span><strong>Email:</strong> {credentials.email}</span>
            <button 
              onClick={() => copyToClipboard(credentials.email)}
              className="text-blue-600 hover:text-blue-800"
            >
              Copy
            </button>
            <span><strong>Password:</strong> {showPassword ? credentials.password : '••••••••'}</span>
            <button 
              onClick={() => setShowPassword(!showPassword)}
              className="text-gray-600 hover:text-gray-800"
            >
              {showPassword ? 'Hide' : 'Show'}
            </button>
            <button 
              onClick={() => copyToClipboard(credentials.password)}
              className="text-blue-600 hover:text-blue-800"
            >
              Copy
            </button>
          </div>
        </div>
      )}
      
      <iframe
        ref={iframeRef}
        src={src}
        title={title}
        className="w-full h-full border-0 rounded-lg"
        allowFullScreen={allowFullScreen}
        sandbox={sandbox}
        loading="lazy"
        style={{
          minHeight: '600px',
          ...style
        }}
      />
    </div>
  );
};

export default WebView;
